module.exports = __webpack_public_path__ + "img/message.b26afc98.svg";